<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            :showAddButton=false
            @handleAddNew="addNewProject"
            :searchFilters="searchFilters"
            @searchPage="searchProjects"
            @resetFilters="resetFilters"
            @importData="importProjects"
            @removeItem="removeProject"
            @removeSelectedItems="removeProjects"
            @printList="printprojectsList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="projectsList"
            :actions="actions"
            :showActions=false
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :groupingKey=true
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveProject" @handleReset="handleReset"
            />
        </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import PrintJS from 'print-js';

export default{
    name: 'Projects',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const idField = 'project_id';
        const addButtonLabel = ref('New Project');
        const title = ref('Project Details');
        const addingRight = ref('Adding Project');
        const removingRight = ref('Deleting Project');
        const rightsModule = ref('HR');
        const submitButtonLabel = ref('Add');
        const selectedIds = ref([]);
        const projectsList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const modal_top = ref('150px');
        const modal_left = ref('400px');
        const modal_width = ref('45vw');
        const catComponentKey = ref(0);
        const brnComponentKey = ref(0);
        const isEditing = computed(()=> store.state.Projects.isEditing);
        const selectedProject = computed(()=> store.state.Projects.selectedProject);
        const selectedSupervisor = computed(()=> store.state.Projects.selectedSupervisor);
        const selectedBranch = computed(()=> store.state.Projects.selectedBranch);
        const usersArray = computed(() => store.state.userData.userArr);
        const branchArray = computed(() => store.state.Branches.branchArr);
        const supervisorID = ref('');
        const branchID = ref('');
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key:"name"},
            {label: "Start Date", key:"from_date"},
            {label: "End Date", key: "to_date"},
            {label: "Supervisor", key:"supervisor"},
            {label: "Branch", key:"branch"},
            {label: "Description", key:"description"},
            {label: "Status", key:"status"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Project', rightName: 'Editing Project'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Project', rightName: 'Deleting Project'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        
        const name_search = ref("");

        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: name_search, width:48,},
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const fetchBranches = async() =>{
            await store.dispatch('Branches/fetchBranches', {company:companyID.value})       
        };
        const handleSelectedBranch = async(option) =>{
            await store.dispatch('Branches/handleSelectedBranch', option)
            branchID.value = store.state.Branches.branchID;
        };
        const clearSelectedBranch = async() =>{
            await store.dispatch('Branches/updateState', {branchID: ''});
            branchID.value = ""
        };
        const fetchUsers = async() =>{
            await store.dispatch('userData/fetchUsers', {company:companyID.value});
        };
        const handleSelectedSupervisor = async(option) =>{
            await store.dispatch('userData/handleSelectedUser', option)
            supervisorID.value = store.state.userData.userID;

        };
        const clearSelectedSupervisor = async() =>{
            await store.dispatch('userData/updateState', {supervisorID: ''});
            supervisorID.value = store.state.userData.supervisorID;
        };
        const formFields = ref([]);
        const supervisorValue = computed(() => {
           return (selectedProject.value && selectedProject.value.supervisor && !supervisorID.value) ? selectedProject.value.supervisor.user_id : supervisorID.value;
        });
        const branchValue = computed(() => {
            return (selectedProject.value && selectedProject.value.branch && !branchID.value) ? selectedProject.value.branch.branch_id : branchID.value;
        });
        const updateFormFields = () => {
            formFields.value = [
                {  
                    type:'search-dropdown', label:"Branch", value: branchValue.value, componentKey: brnComponentKey,
                    selectOptions: branchArray, optionSelected: handleSelectedBranch, required: false,
                    searchPlaceholder: 'Select Branch...', dropdownWidth: '250px', updateValue: selectedBranch.value,
                    clearSearch: clearSelectedBranch()
                },
                {  
                    type:'search-dropdown', label:"Supervisor", value: supervisorValue.value, componentKey: catComponentKey,
                    selectOptions: usersArray, optionSelected: handleSelectedSupervisor, required: false,
                    searchPlaceholder: 'Select Supervisor...', dropdownWidth: '400px', updateValue: selectedSupervisor.value,
                    clearSearch: clearSelectedSupervisor()
                },
                { type: 'text', name: 'name',label: "Name", value: selectedProject.value?.name || '', required: true },
                { type: 'date', name: 'from_date',label: "Start Date", value: selectedProject.value?.from_date || '', required: true },
                { type: 'date', name: 'to_date',label: "End Date", value: selectedProject.value?.to_date || '', required: false },
                { type: 'dropdown', name: 'status',label: "Status", value: selectedProject.value?.status || 'Active', placeholder: "", required: true, options: [{ text: 'Active', value: 'Active' }, { text: 'Inactive', value: 'Inactive' }] },
                { type: 'text-area', name: 'description',label: "Description", value: selectedProject.value?.description || '', required: false,textarea_rows: '2', textarea_cols: '40'},
            ];
        };
        const handleReset = () =>{
            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].name == 'status'){
                    formFields.value[i].value = 'Active';
                }else{
                    formFields.value[i].value = '';
                }
                
            }
            supervisorID.value = "";
            branchID.value = ""
            catComponentKey.value += 1;
            brnComponentKey.value += 1;
        }

        watch([selectedProject, selectedSupervisor, selectedBranch], () => {
            if (selectedProject.value && selectedBranch.value && selectedSupervisor.value) {
                catComponentKey.value += 1;
                brnComponentKey.value += 1;
                updateFormFields();
            }else if(selectedProject.value && selectedBranch.value){
                brnComponentKey.value += 1;
                updateFormFields();                
            }else if(selectedProject.value && selectedSupervisor.value){
                catComponentKey.value += 1;
                updateFormFields();
            }else if(selectedProject.value){
                updateFormFields();
            }
            
        }, { immediate: true });
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createProject = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[2].value,
                from_date: formFields.value[3].value,
                to_date: formFields.value[4].value || null,
                status: formFields.value[5].value,   
                description: formFields.value[6].value,
                supervisor: supervisorID.value,
                supervisor_id: supervisorID.value,
                branch: branchID.value,
                branch_id: branchID.value,
                company: companyID.value
            }
  
            errors.value = [];
            for(let i=2; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != "search-dropdown"){
                    errors.value.push(formFields.value[i].label);
                }
            }

            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Projects/createProject', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Project created successfully!');
                        handleReset();
                    } else {
                        toast.error('An error occurred while creating the Project.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Project: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchProjects();
                }
            }
        }
        const updateProject = async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                project: selectedProject.value.project_id,
                name: formFields.value[2].value,
                from_date: formFields.value[3].value,
                to_date: formFields.value[4].value || null,
                status: formFields.value[5].value,   
                description: formFields.value[6].value,
                supervisor: supervisorValue.value,
                supervisor_id: supervisorValue.value,
                branch: branchValue.value,
                branch_id: branchValue.value,
                company: companyID.value
            }

            for(let i=1; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true && formFields.value[i].type != "search-dropdown"){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Projects/updateProject', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        toast.success("Project updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Project.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Project: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Projects/updateState",{selectedProject:null,  selectedSupervisor: null, selectedBranch:null,})
                    searchProjects();
                }             
            }
        }
        const saveProject = () =>{
            if(isEditing.value == true){
                updateProject();
            }else{
                createProject();
            }
        }
        const importProjects = () =>{
            // store.commit('pageTab/ADD_PAGE', {'FA':'Import_Assets'})
            // store.state.pageTab.faActiveTab = 'Import_Assets';
        }
        const removeProject = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    project: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Projects/deleteProject',formData)
                    if(response && response.status == 200){
                        toast.success("Project Removed Succesfully");
                        searchProjects();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Project: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Project") 
            }else{
                toast.error("Please Select A Project To Remove")
            }
        }
        const removeProjects = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    project: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Projects/deleteProject',formData)
                    if(response && response.status == 200){
                        toast.success("Project(s) Removed Succesfully");
                        searchProjects();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Project: ' + error.message);
                }
                finally{
                    selectedIds.value = [];

                }
            }else{
                toast.error("Please Select A Project To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchProjects = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                company: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/projects-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                projectsList.value = response.data.results;
                store.commit('Projects/LIST_PROJECTS', projectsList.value)
                propResults.value = response.data;
                propArrLen.value = projectsList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchProjects(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            name_search.value = "";
            searchProjects();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchProjects();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchProjects();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchProjects();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchProjects();
            // scrollToTop();
        }
        const addNewProject = () =>{
            updateFormFields();
            store.dispatch("Projects/updateState",{selectedProject:null, selectedSupervisor: null, selectedBranch:null, isEditing:false})
            propModalVisible.value = true;
            handleReset();
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const projectID = row[idField];
                let formData = {
                    company: companyID.value,
                    project: projectID
                }
                await store.dispatch('Projects/fetchProject',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.333';

            }else if(action == 'delete'){
                const projectID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    project: projectID
                }
                await store.dispatch('Projects/deleteProject',formData).
                then(()=>{
                    searchProjects();
                })
            }
        }
        const closeModal = () =>{
            propModalVisible.value = false;
        };
        const printprojectsList = () =>{
            showLoader();

            let formData = {
                name: name_search.value,
                company: companyID.value,
                page_size: selectedValue.value
            }
            axios
            .post("api/v1/export-projects-pdf/", formData, { responseType: 'blob' })
            .then((response)=>{
                if(response.status == 200){
                    const blob1 = new Blob([response.data]);
                    // Convert blob to URL
                    const url = URL.createObjectURL(blob1);
                    PrintJS({printable: url, type: 'pdf'});
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        onBeforeMount(()=>{
            searchProjects();
            fetchBranches();
            fetchUsers();
        })
        return{
            title, searchProjects,resetFilters, addButtonLabel, searchFilters, tableColumns, projectsList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,
            submitButtonLabel, showModal, addNewProject, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveProject, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            importProjects, removeProject, removeProjects, handleReset,printprojectsList,addingRight,removingRight,rightsModule,selectSearchQuantity,selectedValue
        }
    }
};
</script>